import { DMEditor, DMEditorRefType } from "dmeditor";
import { useEffect, useRef } from "react";
import { FetchWithAuth } from "digimaker-ui/util";
import React from "react";
import { useHistory, useLocation } from "react-router";

export const FullEdit = (props: { id: number }) => {
  const editorRef = useRef<DMEditorRefType>(null);
  let contentType = "";
  const history = useHistory();
  const location = useLocation();

  const save = (data) => {
    const postData = {
      title: data.page.title,
    };
    postData["body"] = data.data;

    FetchWithAuth(`content/update/${props.id}`, {
      method: "POST",
      body: JSON.stringify(postData),
    }).then((data) => {
      if (data.error === false) {
        window.alert("Saved. Click to return");
        const from = new URLSearchParams(location.search).get("from");
        history.push(from || "/");
      }
    });
  };

  const cancel = () => {
    window.history.back();
  };

  useEffect(() => {
    const current = editorRef.current;
    if (current) {
      //   current.setPageSettings(pageSettings as any);
    }

    FetchWithAuth(`content/get/${props.id}`)
      .then((data) => {
        if (data.error === false) {
          contentType = data.data.metadata.contenttype;
          const list = data.data["body"] || [];
          const page = {
            title: data.data.title,
            cover_image: data.data.coverimage,
          };
          console.log(list);
          current?.setData(list);
          current?.setPageData(page);
        }
      })
      .catch((d) => {
        window.alert(d.message);
        // nav(`/`);
      });
  }, [props.id]);

  return <DMEditor ref={editorRef} onSave={save} onCancel={cancel} />;
};
